import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalyticsBars = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "analytics-bars" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 21.75,
			x2: 23.25,
			y2: 21.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,11.25H3a.75.75,0,0,0-.75.75v9.75h4.5V12A.75.75,0,0,0,6,11.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.5,2.25h-3A.75.75,0,0,0,9.75,3V21.75h4.5V3A.75.75,0,0,0,13.5,2.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21,6.75H18a.75.75,0,0,0-.75.75V21.75h4.5V7.5A.75.75,0,0,0,21,6.75Z"
		})
	]
});
export default SvgAnalyticsBars;
